import { Popover, Row, Tag } from 'antd'
import { useState } from 'react'
import { Icon } from '@iconify/react'
import '../../tasks.index.css'

const StatusSelector = ({
    value,
    onChange,
    name,
    statusType,
    updateDetails,
}) => {
    const [visible, setVisible] = useState(false)

    const handleSelect = (item) => {
        const payload = { label: item.label, value: item.value }
        onChange?.(payload)
        updateDetails(name, payload)
        setVisible(false)
    }

    // Find selected item from statusType using value.label
    const selectedItem =
        statusType?.length > 0 &&
        statusType.find((item) => item?.label === value?.label)

    const content = (
        <div className="flex flex-col gap-1 w-[160px]">
            {statusType.map((item) => {
                const isSelected = item?.label === value?.label

                return (
                    <Row
                        key={item.value}
                        onClick={() => handleSelect(item)}
                        align="middle"
                        justify="space-between"
                        className={`${isSelected ? '#f7f5ff' : 'hover-bg'}`}
                        style={{
                            columnGap: '2px',
                            backgroundColor: isSelected ? '#f7f5ff' : '',
                            cursor: 'pointer',
                            padding: '8px 20px',
                        }}
                    >
                        <Row
                            className="flex items-center gap-2"
                            align="middle"
                            style={{
                                columnGap: '2px',
                            }}
                        >
                            <div style={{ width: 18 }}>
                                {isSelected && (
                                    <Icon
                                        icon="ic:round-check"
                                        height={18}
                                        width={18}
                                        className="svgColor"
                                    />
                                )}
                            </div>
                            <Tag
                                color={item?.color || 'cyan'}
                                style={{
                                    borderRadius: 5,
                                    fontWeight: 500,
                                    padding: '2px 10px',
                                    margin: 0,
                                    fontSize: '13px',
                                }}
                            >
                                {item.label}
                            </Tag>
                        </Row>
                    </Row>
                )
            })}
        </div>
    )

    return (
        <Popover
            content={content}
            trigger="click"
            placement="bottomLeft"
            open={visible}
            onOpenChange={(open) => setVisible(open)}
            arrow={false}
            styles={{
                root: {
                    minWidth: '230px',
                    width: '230px',
                },
                body: {
                    padding: 0,
                },
            }}
            getPopupContainer={(trigger) => trigger.parentNode}
        >
            <Tag
                color={selectedItem?.color || 'cyan'}
                style={{
                    borderRadius: 5,
                    fontWeight: 500,
                    padding: '2px 10px',
                    margin: 0,
                }}
            >
                {selectedItem?.label || 'Select Status'}
            </Tag>
        </Popover>
    )
}

export default StatusSelector
